import React, { ReactNode } from 'react';
import { View, Pressable } from 'react-native-web';
import CustomText from '../atoms/CustomText';
import SvgClose from '../icons/SvgClose';
import { createPortal } from 'react-dom';

interface ModalProps {
  isVisible: boolean;
  onClose: () => void;
  title?: string;
  children: ReactNode;
  width?: number;
  hideHeader?: boolean;
}

export default function Modal({ isVisible, onClose, title, children, width = 400, hideHeader = false }: ModalProps) {
  if (!isVisible) return null;

  return createPortal(
    <>
      {/* Backdrop */}
      <View
        style={{
          position: 'fixed',
          top: 0,
          left: 0,
          right: 0,
          bottom: 0,
          backgroundColor: 'rgba(0, 0, 0, 0.5)',
          zIndex: 50,
        }}
        onClick={onClose}
      />

      {/* Modal */}
      <View
        style={{
          position: 'fixed',
          top: '50%',
          left: '50%',
          transform: [{ translateX: '-50%' }, { translateY: '-50%' }],
          backgroundColor: 'white',
          borderRadius: 12,
          padding: hideHeader ? 0 : 36,
          minWidth: width,
          maxWidth: '90%',
          maxHeight: '90vh',
          overflowY: 'auto',
          zIndex: 51,
        }}
      >
        {/* Header - Only render if not hidden */}
        {!hideHeader && (
          <View style={{
            flexDirection: 'row',
            justifyContent: 'space-between',
            alignItems: 'center',
            marginBottom: 16,
          }}>
            <CustomText style={{
              fontSize: 20,
              fontWeight: 'bold',
            }}>
              {title}
            </CustomText>
            <Pressable onPress={onClose}>
              <SvgClose width={20} height={20} />
            </Pressable>
          </View>
        )}

        {/* Content */}
        {children}
      </View>
    </>,
    document.body
  );
} 